<template>
   <!-- <img src="../assets/home_hero_bg.png" alt=""> -->
   
   <div id="background">
    <div id="preFormText" style="text-align: center; margin-bottom: 30px;">
        <p style="margin-bottom: 0px; padding-bottom:20px; font-weight: bold; font-size: 23px;">Ovaj događaj ne bi bio moguć bez podrške sledećih sponzora:</p>
        
        <div class="sponzori-container">
          <img src="../sponzori/NIS.png">
          <img class="mali-logo" src="../sponzori/Rivian.png">
          <img src="../sponzori/Yettel.jpg">
          <img class="mali-logo" src="../sponzori/Go2.png">
          <img src="../sponzori/Pepisco.png">
          <img src="../sponzori/KrojacevaSkola.png">
          <img src="../sponzori/StartujInfostud.png">
        </div>
    </div>
</div>
</template>


<style scoped>

  .hero{
      background-image: url("../assets/home_hero_bg.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-attachment: fixed;
      height: 100%;
      left: 0;
      right: 0;
  }

  .sponzori-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.sponzori-container img {
  height: 300px;
  object-fit: contain;
  max-width: 250px;
  padding: 5px;
  transition: transform 0.3s ease;
}

.sponsors-logos img:hover {
  transform: scale(1.05);
}

  @media (max-width: 992px){
      div {
          padding-top: 50px;
      }
  }

  @media (min-width: 768px) {
    #background {
      width: 100%;
      background-image: url("../assets/home_hero_bg.png");
      background-position: center center;
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column; /* Stavlja elemente jedan ispod drugog */
      align-items: center; /* Centriranje po širini */
      justify-content: center; /* Centriranje po visini, ako treba */
    }
    #preFormText {
      width: 50%;
      background: white;
      text-align: center;
      padding: 20px;
      margin-top: 150px;
      border-radius: 10px;
    }
    #preFormText p,
    #preFormText div {
      display: block;
      font-size: 1em;
      font-weight: bold;
      color: #11998e;
      letter-spacing: 1px;
      margin: 25px 0 15px;
      padding-left: 6px;
      font-weight: bold;
    }

    #preFormText,
    form {
      width: 60%; /* Oba elementa imaju istu širinu */
      box-sizing: border-box; /* Osigurava da padding ne utiče na širinu */
    }
  }

  @media (max-width: 768px) {
    #background {
      width: 100%;
      background-color: #11998e;
      display: flex;
      flex-direction: column; /* Stavlja elemente jedan ispod drugog */
      align-items: center; /* Centriranje po širini */
      justify-content: center; /* Centriranje po visini, ako treba */
      padding: 10px 0; /* Razmak oko sadržaja */
    }
    #preFormText {
      width: 50%;
      background: white;
      text-align: center;
      font-weight: bold;
      color: #11998e;
      padding: 20px;
      margin-top: 60px;
      border-radius: 10px;
    }
    #preFormText p {
      color: #11998e;
      display: block;
      font-size: 1em;
      letter-spacing: 1px;
      margin-top: 25px;
      padding-left: 6px;
      font-weight: bold;
    }
    #preFormText,
    form {
      width: 80%; /* Oba elementa imaju istu širinu */
      box-sizing: border-box; /* Osigurava da padding ne utiče na širinu */
    }

    .sponzori-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      gap: 1.5rem;
      align-items: center;
      justify-items: center;
    }

    .sponzori-container img {
      height: 60px;
      max-width: 100%;
      object-fit: contain;
    }

    .sponzori-container .mali-logo
    {
      height: 150px;
      max-width: 100%;
    }

  }


</style>